import api from "../../config/APIConfig";

const { iAxios, apiUri } = api;
const baseUrl = `${apiUri}/`;

const getFake = () =>
  new Promise(async (resolve, reject) => {
    await new Promise((r) => setTimeout(r, 1000));

    resolve({
      success: true,
      payload: {},
    });
  });

const sendCode = (params) =>
  iAxios.post(`${baseUrl}code/send`, params).then((value) => value.data);

const resendCode = (params) =>
  iAxios.post(`${baseUrl}code/resend`, params).then((value) => value.data);

const validateCode = (params) =>
  iAxios.post(`${baseUrl}code/validate`, params).then((value) => value.data);

const GenericAPI = {
  sendCode,
  resendCode,
  validateCode,
  getFake,
};

export default GenericAPI;
